import React, { ReactElement } from 'react';
import { useEffect } from 'react';
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartLegend,
  ChartValueAxis,
  ChartValueAxisItem,
  SeriesClickEvent,
  SeriesType,
} from '@progress/kendo-react-charts';
import { ChartSeriesInterface } from '../Interfaces/Devices/ChartSeriesInterface';
import { Card } from '@progress/kendo-react-layout';
import {
  ExpansionPanel,
  ExpansionPanelContent,
  ExpansionPanelActionEvent,
} from '@progress/kendo-react-layout';
import { Reveal } from '@progress/kendo-react-animation';
import { useHistory } from 'react-router-dom';
import { Loader } from '@progress/kendo-react-indicators';

const OverviewWidgetChart: React.FC<{
  chartTitleText: string;
  chartTitleTextSize?: string;
  chartValueAxisItemtitle: string;
  chartCategoryAxisItem: String[];
  maxChartValueAxisItem: any;
  seriesData: ChartSeriesInterface[];
  chartType?: SeriesType;
  chartSeriesClick?: (event: SeriesClickEvent) => void;
  goToScreen: string;
  isRefreshing?: boolean;
  graphOnclick?: () => void;
}> = ({
  chartTitleText,
  chartTitleTextSize,
  chartValueAxisItemtitle,
  chartCategoryAxisItem,
  maxChartValueAxisItem,
  seriesData,
  chartType,
  chartSeriesClick,
  goToScreen,
  isRefreshing,
  graphOnclick,
}): ReactElement => {
  const history = useHistory();

  const onChartSeriesClick = (event: SeriesClickEvent) => {
    if (chartSeriesClick) {
      chartSeriesClick(event);
    }

    navigate();
  };

  const navigate = () => history.push('/' + goToScreen);

  const [expanded, setExpanded] = React.useState<boolean>(false);

  const [chartCategoryAxisItemValue, setChartCategoryAxisItemValue] =
    React.useState<String[]>([]);

  useEffect(() => {
    var isNotEmpty = seriesData.length > 0 && seriesData[0].count.length > 0;
    setExpanded(isNotEmpty);

    if (isNotEmpty) setChartCategoryAxisItemValue(chartCategoryAxisItem);
  }, [seriesData]);

  const cardOnClick = () => {
    if (graphOnclick) graphOnclick();
    navigate();
  };

  return (
    <div>
      {isRefreshing ? (
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <Loader size="large" type={'pulsing'} />
        </div>
      ) : (
        <ExpansionPanel
          title={chartTitleText}
          expanded={expanded}
          tabIndex={0}
          key={chartTitleText}
          onAction={(event: ExpansionPanelActionEvent) => {
            setExpanded(!expanded);
          }}
        >
          <Reveal>
            {expanded && (
              <ExpansionPanelContent>
                <Card onClick={cardOnClick}>
                  <Chart onSeriesClick={onChartSeriesClick}>
                    <ChartLegend position="top" orientation="horizontal" />
                    <ChartCategoryAxis>
                      <ChartCategoryAxisItem
                        categories={chartCategoryAxisItemValue}
                        startAngle={45}
                        min={0}
                        max={10}
                      />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                      <ChartValueAxisItem
                        title={{
                          text: chartValueAxisItemtitle,
                        }}
                        min={0}
                        max={maxChartValueAxisItem}
                      />
                    </ChartValueAxis>
                    <ChartSeries>
                      {seriesData.map((item, idx) => (
                        <ChartSeriesItem
                          key={idx}
                          type={chartType ?? 'column'}
                          tooltip={{
                            visible: true,
                          }}
                          data={item.count}
                          name={item.status}
                          //color={item.color}
                        />
                      ))}
                    </ChartSeries>
                  </Chart>
                </Card>
              </ExpansionPanelContent>
            )}
          </Reveal>
        </ExpansionPanel>
      )}
    </div>
  );
};

export default OverviewWidgetChart;
